<template>
	<label :aria-disabled="disabled" class="wrapper">
		<input
			:id="id"
			:name="name"
			:value="value"
			:checked="checked"
			:disabled="disabled"
			:aria-disabled="disabled"
			type="radio"
			class="input"
			v-on="inputListeners"
		>
		<div :aria-disabled="disabled" class="radio">
			<t-timpex-icon type="bp" icon="dot"/>
		</div>
		<span :aria-disabled="disabled" class="label">
			{{label}}
		</span>
	</label>
</template>

<script>
import checkboxMixin from './checkboxMixin';
export default {
	name: 'TRadioButton',
	mixins: [checkboxMixin],
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
@import '~@/components/evergreen/scss/primary';

.wrapper {
	display: flex;
	align-items: center;
	cursor: pointer;
	box-sizing: border-box;
	position: relative;
	margin-top: 10px;
	margin-bottom: 10px;
	&:hover input[type='radio']:enabled:checked + .radio {
		background-image:
			linear-gradient(
				to bottom,
				darken(get-color($default, 'startColor'),5%),
				darken(get-color($default, 'endColor'),5%)
			);
	}
	&:focus-within .radio {
		box-shadow: 0 0 0 2px get-color($blue-scale, 'B4A'),
			inset 0 0 0 1px get-color($neutral-scale, 'N5A'),
			inset 0 -1px 1px 0 get-color($neutral-scale, 'N3A');
	}
	&:active input[type='radio']:enabled + .radio {
		background-image: none;
		background-color: get-color($blue-scale, 'B3A');
		box-shadow: inset 0 0 0 1px get-color($blue-scale, 'B5A');
	}
	&:active input[type='radio']:enabled:checked + .radio {
		background-image:
			linear-gradient(
				to bottom,
				darken(get-color($default, 'endColor'),5%),
				darken(get-color($default, 'endColor'),5%)
			);
	}
}

.input {
	border: 0px;
	clip: rect(1px, 1px, 1px, 1px);
	height: 1px;
	overflow: hidden;
	padding: 0px;
	position: absolute;
	white-space: nowrap;
	width: 1px;
	opacity: 0;
	&:not(:checked) + .radio .icon {
		display: none;
	}
	&:checked + .radio {
		color: white;
		background-image: linear-gradient(to bottom, #0788DE, #116AB8);
		box-shadow: inset 0 0 0 1px rgba(67, 90, 111, 0.3), inset 0 -1px 1px 0 get-color($neutral-scale, 'N2A');
	}
	&:focus + .radio {
		box-shadow: 0 0 0 2px get-color($blue-scale, 'B4A'),
			inset 0 0 0 1px get-color($neutral-scale, 'N5A'),
			inset 0 -1px 1px 0 get-color($neutral-scale, 'N3A');
	}
}

.radio {
	height: 12px;
	width: 12px;
	border-radius: 9999px;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;

	-webkit-font-smoothing: antialiased;
	text-decoration: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	border: none;
	outline: none;
	cursor: pointer;
	color: white;
	background-color: white;
	background-image: linear-gradient(to top,
		get-color($neutral-scale, 'N2A'),
		white);
	box-shadow: inset 0 0 0 1px get-color($neutral-scale, 'N4A'),
				inset 0 -1px 1px 0 get-color($neutral-scale, 'N3A');
	&[aria-disabled="true"] {
		color: get-color($icon, 'disabled');
		background-image: linear-gradient(to top, get-color($neutral-scale, 'N2A'), rgba(67, 90, 111, 0.04));
		box-shadow: inset 0 0 0 1px get-color($neutral-scale, 'N4A'),
					inset 0 -1px 1px 0 get-color($neutral-scale, 'N2A');
	}
}

.icon {
	color: white;
	height: 4px;
	width: 4px;
}

.label {
	@extend %text-small;
	@extend %font-families-ui;
	margin-top: 0;
	outline: none;
	user-select: none;
	margin-left: 8px;
	color: get-color($text, 'default');
	box-sizing: border-box;
	&[aria-disabled="true"] {
		color: get-color($text, 'muted');
	}
}

[aria-disabled="true"] {
	cursor: not-allowed;
}

</style>


<docs>
## Examples

### Checkbox states

```jsx
<div>
	<t-radio-button id="1" name="group" label="Radio default"></t-radio-button>
	<t-radio-button id="2" name="group" label="Radio checked" checked></t-radio-button>
	<t-radio-button id="3" name="group" label="Radio disabled" disabled></t-radio-button>
</div>
```
</docs>
